import { Box, Grid, styled, Typography } from "@mui/material";
import { useRouter } from "next/router";
import React, { useEffect, useRef } from "react";
import { sendAnalytics } from "../../utils/analyticsCommon";
import CheckEMICard from "../../../src/modules/EMi/CheckEMICard.js";

const CustomVehicleLoan = styled(Box)(({ theme }) => ({
  width: "100vw",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  marginTop: "48px",
  paddingTop: "12px",
  ".head-text": {
    fontWeight: 600,
    fontSize: "24px",
    display: "block",
    margin: "0px 0px 20px 0px",
  },

  ".sub-text": {
    fontSize: "12px",
    color: "red",
    fontWeight: "600",
    padding: "0px 15px",
    paddingLeft: "6px",
    textTransform: "uppercase",
    marginBottom: "4px",
    display: "block",
  },
  ".head-text-2": {
    padding: "0px 10px ",
    fontWeight: 700,
    fontSize: "24px",
  },
  ".image-box": {
    width: "100%",
    minHeight: "245px",
    padding: "20px 0px",
  },
  ".test-drive-image": {
    width: "100%",
  },
  ".book-test-drive-button": {
    borderRadius: "8px",
    boxShadow: "none",
    border: "none",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  ".MuiOutlinedInput-root": {
    paddingRight: "2px !important",
  },
  ".termsconditions": {
    fontSize: "10px",
  },
  ".vehicles-grid-container": {
    width: "100%",
    padding: "0",
    display: "flex",
    justifyContent: "flex-start",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0%",
    paddingRight: "0%",
    ".head-text": {
      padding: "0px 10px",
      fontWeight: 600,
      fontSize: "24px",
    },
    ".sub-text": {
      fontSize: "12px",
      color: "#9C9A9D",
      fontWeight: "600",
      padding: "0px 10px",
      marginBottom: "0",
      textTransform: "uppercase",
    },
    ".test-drive-image": {
      width: "100%",
      maxHeight: "300px",
    },
    ".main-box": {
      width: "100%",
    },
  },
}));

const BrandVehicleLoan = ({
  headerInfo = "Vehicle Loan",
  cardDetails = {},
  isHindi = false,
}) => {
  const targetRef = useRef(null);
  const navigate = useRouter();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics("v2_scroll_vehicle_loan", {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);

  return (
    <CustomVehicleLoan>
      <Grid
        container
        spacing={3}
        className="vehicles-grid-container"
        id="search-result"
      >
        <Grid item xs={12} style={{ paddingTop: "0px" }}>
          <Box
            id="loan-disbursed"
            className="main-box"
            ref={targetRef}
            style={{ width: "100%" }}
          >
            <Typography variant="h2" className="head-text">
              {headerInfo}
            </Typography>

            {navigate.pathname === "/" && (
              <Box>
                <Typography className="head-text-2">
                  1500+ loan disbursed
                </Typography>
              </Box>
            )}

            {/* for vehicles page full screen loan banner */}
            <Box
              sx={{ display: { xs: "none", md: "block" }, cursor: "pointer" }}
            >
              <CheckEMICard cardDetails={cardDetails} isHindi={isHindi} />
            </Box>

            <Box
              className="image-box"
              sx={{ display: { xs: "block", md: "none" }, cursor: "pointer" }}
            >
              <CheckEMICard cardDetails={cardDetails} isHindi={isHindi} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </CustomVehicleLoan>
  );
};

const MemoizedBrandVehicleLoan = React.memo(BrandVehicleLoan);
export default MemoizedBrandVehicleLoan;
